import React, { useState } from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import "../../styles/Scholarships.css";
import api from "../../utils/api";

const Scholarship = () => {
  const [showModal, setShowModal] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    course: "",
    scholarshipType: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const resetForm = () => {
    setForm({
      name: "",
      email: "",
      phone: "",
      course: "",
      scholarshipType: "",
    });
  };

  const submitForm = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      await api.post("/scholarships/apply", form);
      alert("Scholarship application submitted successfully");
      resetForm();
      setShowModal(false);
    } catch (error) {
      alert(error.response?.data?.message || "Submission failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Navbar />

      <div className='scholarship-container fade-in'>
      <h1 className='page-title'>Scholarship Information</h1>
      <p className='intro-text'>
        Shri Mulikadevi Mahavidyalaya, Nighoj, provides access to various government and institutional scolarships to support deserving students. Below you'll find details on eligibility, documents, and the application process for scholarships available to our students.
      </p>

      {/* ==== Scholarship Cards ==== */}
      <div className='scholarship-card'>
        <h2 className='card-title'>🎓 Government Scholarships</h2>
        <ul className='card=list'>
          <li>Post Matric Scholarship for SC/ST/OBC/VJNT Students</li>
          <li>EBC (Economically Backward Class) Concession</li>
          <li>Minority Scholarship for Students with Disabilities</li>
          <li>State Merit Scholarship</li>
        </ul>
      </div>
      
      <div className="scholarship-card">
        <h2 className="card-title">🏅 Institutional Scholarships</h2>
        <ul className="card-list">
          <li>Mulikadevi Merit Scholarship (Top 3 students of each department)</li>
          <li>Sports Excellence Scholarship</li>
          <li>Girl Child Encouragement Award</li>
        </ul>
      </div>

      <div className='scholarship-card'>
        <h2 className='card-titile'>📋 Required Documents</h2>
        <ul className='card-list'>
          <li>Last Year's Marksheet</li>
          <li>Income Certificate</li>
          <li>Caste Certificate (if applicable)</li>
          <li>Adhar Card Copy</li>
          <li>Bank Passbook Copy</li>
          <li>Passport-size Photo</li>
        </ul>
      </div>

      <div className="scholarship-card">
        <h2 className="card-title">🕒 Application Timeline</h2>
        <ul className="card-list">
          <li>Application Opens: <strong>June 10, 2025</strong></li>
          <li>Last Date to Apply: <strong>August 5, 2025</strong></li>
          <li>Document Verification: <strong>August 10–15, 2025</strong></li>
          <li>Scholarship Disbursement: <strong>September 2025</strong></li>
        </ul>
      </div>

        <div className="btn-container">
          <button className="apply-btn" onClick={() => setShowModal(true)}>
            Apply for Scholarship
          </button>
        </div>

        {showModal && (
          <div className="modal-overlay">
            <div className="modal">
              <button
                className="adm-close-btn"
                onClick={() => setShowModal(false)}
              >
                &times;
              </button>

              <h2 className="modal-title">Scholarship Application Form</h2>

              <form className="scholarship-form" onSubmit={submitForm}>
                <label>Full Name</label>
                <input
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />

                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                />

                <label>Phone</label>
                <input
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  required
                />

                <label>Course</label>
                <select
                  name="course"
                  value={form.course}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Course</option>
                  <option value="B.Sc. Computer Science">
                    B.Sc. Computer Science
                  </option>
                  <option value="B.A.">B.A.</option>
                  <option value="B.Sc.">B.Sc.</option>
                </select>

                <label>Scholarship Type</label>
                <select
                  name="scholarshipType"
                  value={form.scholarshipType}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Scholarship</option>
                  <option value="Government">Government Scholarship</option>
                  <option value="Institutional">
                    Institutional Scholarship
                  </option>
                </select>

                <button
                  type="submit"
                  className="submit-btn"
                  disabled={submitting}
                >
                  {submitting ? "Submitting..." : "Submit Application"}
                </button>
              </form>
            </div>
          </div>
        )}
      </div>

      <Footer />
    </>
  );
};

export default Scholarship;
